import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3e4vs8oo35phc13l6qg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-blue-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Stay Updated on Market Trends
        </h2>
        <p className="text-xl text-blue-100 mb-8">
          Get exclusive insights, investment tips, and market updates delivered to your inbox.
        </p>
        
        <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-blue-300 text-sm"
              placeholder="Enter your email address"
            />
            <Button 
              type="submit" 
              variant="secondary" 
              disabled={isSubmitting}
              className="bg-white text-blue-600 hover:bg-gray-100"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </Button>
          </div>
          
          {submitStatus === 'success' && (
            <div className="mt-4 p-3 bg-green-100 border border-green-300 rounded-lg">
              <p className="text-green-800 text-sm">Thank you for subscribing!</p>
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="mt-4 p-3 bg-red-100 border border-red-300 rounded-lg">
              <p className="text-red-800 text-sm">Sorry, there was an error. Please try again.</p>
            </div>
          )}
        </form>
        
        <p className="text-blue-200 text-sm mt-4">
          No spam, unsubscribe at any time.
        </p>
      </div>
    </section>
  );
}